import { initializeBasicUserHelp } from "./basicUserHelpFunction";
import { switchToSearchFilter } from "./searchFilterFunctions";

// Funktion zum Setzen des Cookies
function setCookie(cookieName, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = cookieName + "=" + (value || "");
  document.cookie = "expires=" + date.toUTCString();
  document.cookie = "path=/";
}

// Funktion zum Lesen des Cookies
export async function getUserTypeCookie(cookieName) {
  let savedCookieValue = null;
  let savedCookieName = "";

  cookieName = encodeURIComponent(cookieName);

  //Read Cookie from Browser
  const cookieValuesArray = document.cookie.split(";");

  // Iterate over each Cookie
  cookieValuesArray.forEach((currentElement) => {
    //get CookieName
    savedCookieName = currentElement.substring(0, currentElement.indexOf("="));
    savedCookieName = savedCookieName.replace(/ /g, "");

    //If a Cookie with the given Name is found, set CookieName
    if (savedCookieName == cookieName) {
      savedCookieValue = currentElement.substring(
        currentElement.indexOf("=") + 1
      );
    }
  });

  return savedCookieValue;
}

// Funktion zur Auswahl des Benutzertyps und Setzen des entsprechenden Cookies
export function setUserTypeCookie(userType) {
  setCookie("userType", encodeURIComponent(userType), 30); // Cookie für 30 Tage setzen
}

/**
 *Prüft welches Cookie beim User gesetzt ist und führt die entsprechende Logik aus
 *
 * @export
 */
export async function checkUserCookieStatus() {
  let cookieValuePromise = await getUserTypeCookie("userType").then(
    (awaitedCokkieValue) => {
      // Zeige Wilkommens fensteran
      if (!awaitedCokkieValue) {
        bootstrap.Modal.getOrCreateInstance(document.getElementById("staticBackdrop")).show();
      } else if (awaitedCokkieValue == "expertUser") {
        switchToSearchFilter();
      } else if (awaitedCokkieValue == "BasicUser") {
        initializeBasicUserHelp();
      }
    }
  );
}
